export default "__VITE_ASSET__jw34mfe3__"